module.exports = __webpack_public_path__ + "static/media/x.25bdb36c.svg";